// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3ENxE","containerItemsCenter":"Skeleton_containerItemsCenter__2hTf-"};